import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import useApplicationOwnerName from '../../hooks/useApplicationOwnerName';
import { useMenu } from '../../hooks/useMenu';
import useStepPost from '../../hooks/useStepPost';
import useApplicationOwnerCountry from '../../hooks/useApplicationOwnerCountry';
import useJointApplicationOwnerCountries from '../../hooks/useJointApplicationOwnerCountries';
import useIsBackUpWithHoldingDispatch from '../../hooks/useIsBackUpWitholdingDispatch';
import { useApplicantData } from '../../hooks/useApplicantData';
import { getApplicantData } from '../../util/helpers/applicantDataHelper';
import OnBoardingContainer from '../../components/OnBoarding/OnBoardingContainer';
import { HeadingSubtitle } from '../../components/Heading';
import SelectList from '../../components/SelectList/SelectList';
import themeColors from '../../assets/styles/themeColors';
import { selectSettings } from '../../store/selectors/settingsSelectors';

const SecureAccountIRSSubject = ({ applicantType }) => {
  const { t } = useTranslation();
  const applicantName = useApplicationOwnerName(applicantType);
  const { activeMenu, activeItem } = useMenu();
  const { onSuccess } = useStepPost({ nextPath: activeItem?.nextPath });
  const { identityCountry } = useApplicationOwnerCountry();
  const { secondaryIdentityCountry } = useJointApplicationOwnerCountries();
  const { backUpWithHoldingDispatch } = useIsBackUpWithHoldingDispatch();
  const ApplicantData = useApplicantData();
  const { BrokerName } = useSelector(selectSettings);

  const items = [
    {
      title: t('secureIdentityIRSSubject.me'),
      onClick: () => {
        onSubmit('Primary');
      },
      disabled: identityCountry !== 'USA',
    },
    {
      title: t('secureIdentityIRSSubject.secondary', {
        name: applicantName,
      }),
      onClick: () => onSubmit('Secondary'),
      disabled: secondaryIdentityCountry !== 'USA',
    },
    {
      title: t('secureIdentityIRSSubject.both'),
      onClick: () => onSubmit('Both'),
      showDivider: false,
      disabled: !(
        identityCountry === 'USA' && secondaryIdentityCountry === 'USA'
      ),
    },
  ];

  const onSubmit = (personTargetType) => {
    const shouldUpdate = getApplicantData(
      ApplicantData,
      'PersonBackupWithHolding',
      'BackupWithHoldingRecord',
    );

    backUpWithHoldingDispatch({
      data: {
        IsSubjectToBackupWithholdings: true,
      },
      shouldUpdate,
      personTargetType,
      onSuccess,
    });
  };

  return (
    <OnBoardingContainer
      activeMenu={activeMenu}
      activeItem={activeItem}
      previousPath={activeItem?.previousPath}
    >
      <Helmet>
        <title>
          {t('titleTagIrs', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <HeadingSubtitle mb={32} color={themeColors.colorTextSecondary}>
        {t('secureIdentityIRSSubject.title')}
      </HeadingSubtitle>
      <SelectList options={items} />
    </OnBoardingContainer>
  );
};
SecureAccountIRSSubject.propTypes = {
  applicantType: PropTypes.string,
};
export default SecureAccountIRSSubject;
